/**
 * getBlen.js
 *
 * @Author: apple
 * @Date: 2017/12/26 16:00
 */

const getBLen = str => {
  if (str === null) return 0;
  if (typeof str !== 'string') {
    str += '';
  }
  return Math.floor(str.replace(/[^\x00-\xff]/g, '01').length / 2);
};

const getBLenNew = str => {
  if (str === null) return 0;
  if (typeof str !== 'string') {
    str += '';
  }
  return Math.ceil(str.replace(/[^\x00-\xff]/g, '01').length / 2);
};

export { getBLenNew };

export default getBLen;
